module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    attrs: {
      "id": "cardInfo.id"
    }
  }, [_c('div', {
    staticClass: "title-box",
    on: {
      "click": _vm.tourl
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "item-list"
  }, [_c('ul', _vm._l((_vm.itemList), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "itemli",
      on: {
        "click": function($event) {
          return _vm.intourl(item)
        }
      }
    }, [_c('span', {
      staticClass: "textspan"
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4b8d7c0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/recommend.vue
// module id = 1078
// module chunks = 2